export default {
  getSearchForm(context) {
    context.getters.searchForm
  },
}
